import { Spin } from 'antd'

import Box from '~/core/Box'
import Text from '~/core/Text'
import { ReorderPartViewerFooterDataType } from '~/apps/consumer/components/PartViewerModal/types'

export default function ReorderFooter(props: {
    reorderFooterData?: ReorderPartViewerFooterDataType
}) {
    const { reorderFooterData } = props

    return (
        <Box
            direction="row"
            justifyContent="start"
            padding="18px 18px 0px 18px"
        >
            <Box direction="col">
                <Box direction="col">
                    <Text fontSize="14px">Production Speed</Text>
                    {reorderFooterData?.productionSpeed ? (
                        <Text fontSize="20px" fontWeight={500}>
                            {reorderFooterData.productionSpeed}
                        </Text>
                    ) : (
                        <Spin />
                    )}
                </Box>
                <Box direction="col" paddingTop="15px">
                    <Text fontSize="14px">Produced by</Text>
                    <Text fontSize="20px" fontWeight={500}>
                        {reorderFooterData?.producedByDate}
                    </Text>
                </Box>
            </Box>
            <Box direction="col" paddingLeft="45px">
                <Box direction="col">
                    <Text fontSize="14px">Quantity</Text>
                    <Text fontSize="20px" fontWeight={500}>
                        {reorderFooterData?.quantity}
                    </Text>
                </Box>
                <Box direction="col" paddingTop="15px">
                    <Text fontSize="14px">Total price</Text>
                    <Text fontSize="20px" fontWeight={500}>
                        {reorderFooterData?.subTotal}
                    </Text>
                </Box>
            </Box>
        </Box>
    )
}
